const ALL_ANNOTATIONS = 'All Annotations';
const FILTERING_ANNOTATIONS = 'Filtering Annotations';
const MY_ANNOTATIONS = 'My Annotations';
const NO_ANNOTATIONS = 'No Annotations';

export {
  ALL_ANNOTATIONS,
  FILTERING_ANNOTATIONS,
  MY_ANNOTATIONS,
  NO_ANNOTATIONS,
};
